import { authRequest } from './client';
import {
  type AssetListItem,
  type CreateAssetInput,
  type ListAssetsResponse,
  type UpdateAssetInput,
} from './types';

// ─── backoffice-api assets client ──────────────────────────────────────────
//
// Thin fetch wrappers around backoffice-api's `/v1/assets` endpoints (Task
// 29 Part A). CONFIG_MANAGER-gated end to end (list/create/update) — no
// DELETE exists on this resource, `updateAsset(id, { enabled: false })` is
// the retirement path.

export function listAssets(): Promise<ListAssetsResponse> {
  return authRequest<ListAssetsResponse>('/assets');
}

export function createAsset(input: CreateAssetInput): Promise<AssetListItem> {
  return authRequest<AssetListItem>('/assets', { method: 'POST', body: JSON.stringify(input) });
}

export function updateAsset(id: string, input: UpdateAssetInput): Promise<AssetListItem> {
  return authRequest<AssetListItem>(`/assets/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
}
